<template>
  <gas-page-shell :breadcrumb="['设备管理', '终端列表']">
    <el-form :inline="true" :model="query" size="small" class="search-form">
      <el-form-item label="所属机构">
        <el-select v-model="query.orgId" clearable placeholder="全部机构" style="width:160px">
          <el-option v-for="o in orgOptions" :key="o.orgId" :label="o.orgName" :value="o.orgId" />
        </el-select>
      </el-form-item>
      <el-form-item label="在线状态">
        <el-select v-model="query.onlineStatus" clearable placeholder="全部" style="width:120px">
          <el-option label="在线" value="online" /><el-option label="离线" value="offline" /><el-option label="告警" value="alarm" />
        </el-select>
      </el-form-item>
      <el-form-item label="关键词"><el-input v-model="query.keyword" clearable placeholder="终端名/编号" /></el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetQuery(() => { query.orgId=null; query.onlineStatus='' })">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="toolbar table-title-row">
      <div class="table-title-group">
        <span class="table-title">终端列表 <em>共 {{ total }} 条记录</em></span>
        <gas-table-toolbar
          :columns="tableColumnDefs"
          :visible-map.sync="tableColumnVisible"
          :selected-count="selectedIds.length"
          :show-batch-delete="tableCanBatchDelete"
          @batch-delete="batchRemove"
        />
      </div>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate(emptyForm())">新增终端</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border size="small" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="44" align="center" />
      <el-table-column prop="terminalCode" label="终端编号" min-width="120" />
      <el-table-column prop="terminalName" label="终端名称" min-width="120" />
      <el-table-column prop="terminalType" label="终端类型" width="100" />
      <el-table-column prop="model" label="型号" width="90" />
      <el-table-column label="在线状态" width="96">
        <template slot-scope="{ row }"><gas-status-tag kind="online" :value="row.onlineStatus" /></template>
      </el-table-column>
      <el-table-column prop="installAddress" label="安装地址" min-width="140" show-overflow-tooltip />
      <el-table-column label="所属机构" min-width="120">
        <template slot-scope="{ row }">{{ orgName(row.orgId) }}</template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" min-width="150" />
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="openEdit(row, emptyForm())">编辑</el-button>
          <el-button type="text" size="small" class="danger" @click="removeRow(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background layout="total, sizes, prev, pager, next"
      :total="total" :current-page="query.pageNum" :page-size="query.pageSize"
      :page-sizes="[10,20,50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px">
      <el-form :model="form" label-width="100px" size="small">
        <el-form-item label="所属机构">
          <el-select v-model="form.orgId" style="width:100%">
            <el-option v-for="o in orgOptions" :key="o.orgId" :label="o.orgName" :value="o.orgId" />
          </el-select>
        </el-form-item>
        <el-form-item label="终端编号"><el-input v-model="form.terminalCode" :disabled="!!form.terminalId" /></el-form-item>
        <el-form-item label="终端名称"><el-input v-model="form.terminalName" /></el-form-item>
        <el-form-item label="终端类型">
          <el-select v-model="form.terminalType" clearable filterable placeholder="请选择终端类型" style="width:100%">
            <el-option v-for="t in deviceTypeOptions" :key="t" :label="t" :value="t" />
          </el-select>
        </el-form-item>
        <el-form-item label="型号"><el-input v-model="form.model" /></el-form-item>
        <el-form-item label="在线状态">
          <el-select v-model="form.onlineStatus" style="width:100%">
            <el-option label="在线" value="online" /><el-option label="离线" value="offline" /><el-option label="告警" value="alarm" />
          </el-select>
        </el-form-item>
        <el-form-item label="安装地址"><el-input v-model="form.installAddress" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="dialogVisible=false">取消</el-button><el-button type="primary" @click="submitForm">保存</el-button></span>
    </el-dialog>
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import gasCrudPage from '@/mixins/gasCrudPage'
import deviceTypeOptionsMixin from '@/mixins/deviceTypeOptions'
import { gasApi } from '@/api/gas'

const emptyForm = () => ({ onlineStatus: 'offline' })

export default {
  components: { GasPageShell },
  mixins: [gasCrudPage, deviceTypeOptionsMixin],
  data() {
    return {
      loadOrgOptions: true,
      idField: 'terminalId',
      listApi: gasApi.terminal.list,
      saveApi: gasApi.terminal.save,
      removeApi: gasApi.terminal.remove,
      batchRemoveApi: gasApi.terminal.batchRemove,
      query: { pageNum: 1, pageSize: 10, keyword: '', orgId: null, onlineStatus: '' }
    }
  },
  created() {
    this.loadDeviceTypeOptions()
  },
  methods: {
    emptyForm,
    async submitForm() {
      if (!this.form.terminalCode || !this.form.terminalName) return this.$message.warning('请填写终端编号和名称')
      await gasCrudPage.methods.submitForm.call(this)
    }
  }
}
</script>

<style scoped>
.toolbar { margin-bottom:12px; display:flex; gap:8px; }
.search-form { margin-bottom:8px; }
.pager { margin-top:16px; text-align:right; }
.danger { color:#f53f3f; }
</style>
